// Function to modify the message based on conditions, language, and translation key
export const ModifyQuestionTranslationText = ({message, params, language}) => {
  // Check if travelers is 1 and modify accordingly

  if (message) {
    if (Number(params?.travelers) === 1) {
      if (language === 'en') {
        message = message?.replaceAll('persons', 'person');
        message = message?.replaceAll('We', 'I');
      } else if (language === 'nl') {
        message = message?.replaceAll('personen', 'persoon');
        message = message?.replaceAll('Wij', 'Ik');
      }
    }

    // Check if nightsCount is 1 and modify accordingly
    if (Number(params?.nightsCount) === 1) {
      if (language === 'en') {
        message = message?.replaceAll('nights', 'night');
      } else if (language === 'nl') {
        message = message?.replaceAll('nachten', 'nacht');
      }
    }
  }

  return message;
};
